import { TagProps } from "@chakra-ui/react";
import { Message } from "features/Resources/Message/models";
import { blueStyles, errorStyles, grayStyles, greenStyles } from "components/Tag/Status/styles";
import BaseActionStatus from "components/Tag/Status/BaseActionStatus";
import { titleize } from "helpers/string";
import { longAttributeStyles } from "components/DataDisplay/styles";
import { HorizontalGreyBlackField } from "components/DataDisplay/GreyBlackField";

interface MessageStatusProps extends TagProps {
  status: Message["status"];
}

function messageStatusStyles(status: Message["status"]) {
  switch (status) {
    case "delivered":
      return greenStyles;
    case "failed":
      return errorStyles;
    case "skipped":
      return grayStyles;
    case "pending":
      return blueStyles;
    default:
      return {};
  }
}

export function ShortMessageStatus({ status, ...rest }: MessageStatusProps) {
  if (status === "pending") return null;
  return (
    <BaseActionStatus {...messageStatusStyles(status)} {...rest}>
      {titleize(status)}
    </BaseActionStatus>
  );
}

export function FullMessageStatus({ status, ...rest }: MessageStatusProps) {
  if (status === "pending") return null;
  return (
    <BaseActionStatus {...messageStatusStyles(status)} {...rest}>
      {titleize(status)}
    </BaseActionStatus>
  );
}

export function ShowMessageStatus({ status, ...rest }: MessageStatusProps) {
  return (
    <HorizontalGreyBlackField label="Status" labelContainerProps={longAttributeStyles.labelContainerProps}>
      <FullMessageStatus status={status} {...rest} />
    </HorizontalGreyBlackField>
  );
}
